<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a routerLink="/page/dashboard"
        ><i class="icon text-info fa fa-home"></i
      ></a>
    </li>
    <li class="breadcrumb-item">
      <a routerLink="/page/project-license-information">{{
        "Form.ActiveLicense" | translate
      }}</a>
    </li>
    <li class="breadcrumb-item active" aria-current="page">
      {{ "Form.Placeholder.TransactionDetails" | translate }}
    </li>
  </ol>
</nav>

<div class="main-card mb-3 p-4 card" *ngIf="data" style="height: 650px">
  <div>
    <h2>{{ "Form.Placeholder.TransactionDetails" | translate }}</h2>
    <hr />
  </div>
  <div *ngIf="loading; else notLoading" class="loaderdata">
    <div class="spinner-border" role="status">
      <span class="sr-only">{{ "Form.Loading" | translate }}</span>
    </div>
  </div>
  <ng-template #notLoading>
    <div class="details">
      <div>
        <p *ngIf="data.id">
          <span>{{ "Form.TransactionId" | translate }}</span> {{ data.id }}
        </p>
        <p>
          <span>{{ "Form.OrderId" | translate }}</span>
          {{ data.order_id || "NA" }}
        </p>
        <p *ngIf="data.status">
          <span>{{ "Form.TransactionStatus" | translate }}</span>
          {{
            data.status == "captured" && data.captured ? "success" : data.status
          }}
        </p>
        <p *ngIf="data.amount && data.currency">
          <span>{{ "Form.TransactionAmount" | translate }}</span>
          {{ data.amount / 100 }} {{ data.currency }}
        </p>
        <p *ngIf="data.method">
          <span>{{ "Form.TransactionMode" | translate }}</span>
          {{ data.method }}
        </p>
        <p *ngIf="data.acquirer_data?.rrn">
          <span>{{ "Form.RRN" | translate }}</span> {{ data.acquirer_data.rrn }}
        </p>
        <p *ngIf="data.acquirer_data?.bank_transaction_id">
          <span>{{ "Form.BanktransactionId" | translate }}</span>
          {{ data.acquirer_data.bank_transaction_id }}
        </p>
        <p *ngIf="data.vpa">
          <span>{{ "Form.VPA" | translate }}</span> {{ data.vpa }}
        </p>
        <p *ngIf="data.wallet">
          <span>{{ "Form.Wallet" | translate }}</span> {{ data.wallet }}
        </p>
        <p *ngIf="data.card?.network">
          <span>{{ "Form.CardNetwork" | translate }}</span>
          {{ data.card.network }}
        </p>
        <p *ngIf="data.card?.last4">
          <span>{{ "Form.CardNumber" | translate }}</span> **** **** ****
          {{ data.card.last4 }}
        </p>
        <p>
          <span>{{ "Form.Contact" | translate }}</span>
          {{ data.contact || "NA" }}
        </p>
        <p>
          <span>{{ "Form.Description" | translate }}</span>
          {{ data.description || "NA" }}
        </p>
        <p>
          <span>{{ "Form.TransactionDate" | translate }}</span>
          {{ getTransactionDateTime(data.created_at) }}
        </p>
      </div>
    </div>
    <div
      class="customer-details"
      *ngIf="
        data.error_code ||
        data.error_description ||
        data.error_source ||
        data.error_step ||
        data.error_reason
      "
    >
      <h3>{{ "Form.ErrorDetails" | translate }}</h3>
      <p>
        <span>{{ "Form.ErrorCode" | translate }}</span>
        {{ data.error_code || "NA" }}
      </p>
      <p>
        <span>{{ "Form.ErrorDescription" | translate }}</span>
        {{ data.error_description || "NA" }}
      </p>
      <p>
        <span>{{ "Form.ErrorSource" | translate }}</span>
        {{ data.error_source || "NA" }}
      </p>
      <p>
        <span>{{ "Form.ErrorStep" | translate }}</span>
        {{ data.error_step || "NA" }}
      </p>
      <p>
        <span>{{ "Form.ErrorReason" | translate }}</span>
        {{ data.error_reason || "NA" }}
      </p>
    </div>
  </ng-template>
</div>
